module.exports = __webpack_public_path__ + "img/spribe.96bac85e.jpg";